module.exports = __webpack_public_path__ + "static/media/freeCodeCampLogo.08550710.jpg";